import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DetailsComponent from "../../components/career/details-component";
import SubHeader from "../../components/career/sub-header";
import axios from "axios";
import apiUrls  from "../../config/api-urls";
import tokenService from "../../services/token-service";


const JobDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [jobData, setJobData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = tokenService.getToken();
  const fetchJobDetails = async () => {
    try {
      const response = await axios.get(`${apiUrls.jobs.job}/${id}`,
        {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    })
      setJobData(response.data.job);
    } catch (error) {
      setError(
        error?.message || "Something went wrong. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchJobDetails();
    }
  }, [id]);

  if (loading) {
    return <p className="text-center">Loading...</p>;
  }

  if (error) {
    return <p className="text-center text-red-600">{error}</p>;
  }

  const handleApply = () => {};
  return (
    <>
      <SubHeader jobData={jobData} />
      <DetailsComponent jobData={jobData} onApply={handleApply} />
    </>
  );
};

export default JobDetails;
